var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMechanicalExtractFanCookerHobHood01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.15;stroke-miterlimit:10;}\n\t.st1{stroke:#FFFFFF;stroke-width:0.15;stroke-miterlimit:10;fill:#FFFFFF}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 8,
    cy: 8,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8,4.5v3.6H4.5C4.6,7,5,6,5.8,5.2C6.4,4.7,7.2,4.4,8,4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.5,8.1H8V4.6c1.1,0.1,2,0.5,2.8,1.3C11.3,6.5,11.6,7.3,11.5,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8,11.5V8.1h3.5c-0.1,1-0.5,2-1.3,2.7C9.6,11.3,8.8,11.6,8,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.5,8.1H8v3.4c-1-0.1-2-0.5-2.8-1.2C4.7,9.7,4.4,8.9,4.5,8.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.5,
    y1: 7.7,
    x2: 13.5,
    y2: 7.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.6,
    y1: 9.1,
    x2: 13.5,
    y2: 9.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMechanicalExtractFanCookerHobHood01);
export default __webpack_public_path__ + "static/media/MechanicalExtractFanCookerHobHood-01.7617a9d0da64c1940a9c79778852380f.svg";
export { ForwardRef as ReactComponent };